<template>
  <div class="inner-box color-666">
    <div class="flex-between">
      <h1>{{ positionInfo.jobTitle }}</h1>
      <el-button type="primary" round @click="goApply(positionInfo.id)"
        >申请职位</el-button
      >
    </div>
    <p class="font-16">
      <span class="color-primary font-bold">{{
        positionInfo.regularSalary
      }}</span>
      {{ positionInfo.workCity }} 丨 {{ positionInfo.department }}-{{
        positionInfo.candidateDepartment
      }}
      丨 {{ positionInfo.jobType }}-{{ positionInfo.jobCategory }} 丨
      {{ positionInfo.zplxName }}
    </p>

    <p class="title">职位描述</p>
    <p v-html="positionInfo.duty"></p>
    <p class="color-333 font-bold">注：待遇为转正薪资</p>
    <p class="title">职位要求</p>
    <p v-html="positionInfo.require"></p>

    <div class="bg-f7 color-666" v-if="positionInfo.candidateDepartment=='CS'">
      <p>
        盘云科技着眼于培养优秀的应届毕业生快速获取岗位需具备的知识技能和展现实力，配备从实习期到毕业后3年的完整人才学习与发展计划，与此同时将配以具有市场竞争水平的福利待遇。其基本组成符合公司整体薪酬架构，在每年薪资调整时，对优秀人才给予额外激励，配以较大幅度的薪资调整和福利待遇。如果能顺利通过各阶段培养及检验，毕业两年年薪可达20万+，未来更有更多的发展机会让优秀人才前途无限量。
      </p>
      <p class="color-333 font-bold" style="margin-bottom:8px;">我们将为每一位学员提供：</p>
      <p>
        1、导师制个性化培训：提供掌握当下最热的各项云技术技能的机会，把脉行业技术未来，快速解锁你的职场IT技能；
        2、职业发展目标多元化：根据个人发展及公司实际情况，提供多通道职业发展路径，业务路径+专业路径+管理路径，确保个人与公司共同发展；
      </p>
    </div>
  </div>
</template>

<script>
import myApi from "../utils/api";
import util from "./../utils/util";

export default {
  data() {
    return {
      positionInfo: "", //职位信息
      visitId: "",
    };
  },
  created() {
    this.findJobInfo();
    util.getVisitor("3", this.$route.params.id).then((res) => {
      this.visitId = res;
    }); //page 3职位详情 pv uv
  },
  beforeDestroy() {
    myApi.updateVisitTime({
      id: this.visitId,
    });
  },
  methods: {
    // 获取对应的职位信息
    findJobInfo() {
      console.log(this.$route);
      myApi
        .findJobById({
          id: this.$route.params.id,
        })
        .then((res) => {
          this.positionInfo = res;
          this.$set(
            this.positionInfo,
            "duty",
            this.positionInfo.duty.replace(/\n/g, "<br>")
          );
          this.$set(
            this.positionInfo,
            "require",
            this.positionInfo.require.replace(/\n/g, "<br>")
          );
        });
    },
    goApply(id) {
      this.$router.push(`/apply/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.inner-box {
  width: 1028px;
  margin: 0 auto;
  padding: 40px 0 92px;
  .flex-between {
    margin-bottom: 16px;
  }
  h1 {
    font-size: 30px;
    line-height: 48px;
    font-weight: 600;
    color: #333333;
  }
  .el-button {
    height: 48px;
    width: 180px;
    border-radius: 24px;
    font-size: 16px;
  }
  .title {
    margin: 56px 0 26px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
  }
  p {
    max-width: 768px;
    text-align: left;
    line-height: 28px;
  }
  .color-primary {
    margin-right: 16px;
  }
  .color-333 {
    margin-top: 16px;
  }
  .bg-f7{
     max-width: 768px;
     padding:32px 18px;
    margin-top:24px;
  }
}

</style>